import React from 'react';

import classes from './ContentWrapper.module.pcss';

export default ({children}) => <div className={classes.ContentWrapper}>{children}</div>;
